module.exports = __webpack_public_path__ + "static/media/meteor-dribbble-4.8f2d39fd.jpg";